import { render, staticRenderFns } from "./configOwnerOption.vue?vue&type=template&id=616931be&scoped=true"
import script from "./configOwnerOption.vue?vue&type=script&lang=js"
export * from "./configOwnerOption.vue?vue&type=script&lang=js"
import style0 from "./configOwnerOption.vue?vue&type=style&index=0&id=616931be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616931be",
  null
  
)

export default component.exports